import { createDirtyChecker, compareByPaths } from "../../gvc/testNewForm/createDirtyChecker";
import { inputToAgent } from "../utils";

export function getDirtyChecker(id: string) {
  return createDirtyChecker(id, inputToAgent, compareByPaths({
    description: { path: "description" },
    tags: { path: "tags" },
  }));
}
